var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.96191H14V5.96191C14 5.43148 13.7893 4.92277 13.4142 4.5477C13.0391 4.17263 12.5304 3.96191 12 3.96191C11.4696 3.96191 10.9609 4.17263 10.5858 4.5477C10.2107 4.92277 10 5.43148 10 5.96191L10.071 9.96191H6C5.46957 9.96191 4.96086 10.1726 4.58579 10.5477C4.21071 10.9228 4 11.4315 4 11.9619C4 12.4923 4.21071 13.0011 4.58579 13.3761C4.96086 13.7512 5.46957 13.9619 6 13.9619L10.071 13.8909L10 17.9619C10 18.4923 10.2107 19.0011 10.5858 19.3761C10.9609 19.7512 11.4696 19.9619 12 19.9619C12.5304 19.9619 13.0391 19.7512 13.4142 19.3761C13.7893 19.0011 14 18.4923 14 17.9619V13.8909L18 13.9619C18.5304 13.9619 19.0391 13.7512 19.4142 13.3761C19.7893 13.0011 20 12.4923 20 11.9619C20 11.4315 19.7893 10.9228 19.4142 10.5477C19.0391 10.1726 18.5304 9.96191 18 9.96191Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.1c142163ba34215ed533c33c995570e8.svg";
export { ForwardRef as ReactComponent };